import { createContext, useContext } from "react";
import useAddInvestmentForm from "../hooks/useAddInvestmentForm";
import useHubspotLink from "../hooks/useHubspotLink";
import useReplaceMainUserForClient from "../hooks/useReplaceMainUserForClient";
import useSendInviteEmail from "../hooks/useSendInviteEmail";
import useStripeLink from "../hooks/useStripeLink";
import useUpdateClientDetails from "../hooks/useUpdateClientDetails";
import { Address, User } from "../types";

export type ClientDetails = {
  [key: string]: unknown;
  name: string;
  address: Address;
  mainUser?: User & {
    stripeInvoicesUrl?: string;
    hubspotUrl?: string;
    stripeUrl?: string;
    imageUrl?: string;
  };
  dateCreated?: number;
  lastUpdated?: number;
  imageUrl?: string;
  pricingPlan?: {
    level: string;
    billingInterval?: string;
  };
  products?: string[];
  isPrivateLedger?: boolean;
};
export interface ClientDetailsContextValue {
  linkToHubspot: ReturnType<typeof useHubspotLink>;
  linkToStripe: ReturnType<typeof useStripeLink>;
  sendInviteEmail: ReturnType<typeof useSendInviteEmail>;
  replaceMainUser: ReturnType<typeof useReplaceMainUserForClient>;
  updateClientDetails: ReturnType<typeof useUpdateClientDetails>;
  addInvestment: ReturnType<typeof useAddInvestmentForm>;
  client: {
    loading: boolean;
    error: Error | null;
    details: ClientDetails | null;
  };
  clientId: string;
}

export const ClientDetailsContext =
  createContext<ClientDetailsContextValue | null>(null);
export const useClientDetails = () => {
  const context = useContext(ClientDetailsContext);

  if (!context) {
    throw new Error(
      "useClientDetails must be used within a ClientDetailsProvider",
    );
  }

  return context;
};
